import React, { useState, useEffect } from 'react';
import {useLocation} from 'react-router-dom';
import auth from '../../services/authentication';
import TrovaLogo from '../TrovaLogo/TrovaLogo';
import SearchInput from "../SearchInput/SearchInput";
import {Container, Row, Col} from 'react-bootstrap';
import Box from '../../styled/Box';
import NavRight from './NavRight';

interface NavigationProps{
  logoText?: boolean,
  hasLogo?: boolean,
}

const Navigation = React.memo(({ logoText = false, hasLogo = true }: NavigationProps) => {
  let location = useLocation();
  const [isAuth, setIsAuth] = useState(auth.isAuthenticated());

  useEffect(() => {
    setIsAuth(auth.isLoggedIn);
  }, [auth.isLoggedIn]);

  if (isAuth && location.pathname.includes('searchresults')) {
    return (
      <Box
        padding={'15px 15px 45px'}
        alignItems={'center'}
        display={'flex'}
        width={'100%'}
        background={'linear-gradient( rgba(149,190,249,0.8),rgba(149,190,249,0.02))'}
      >
        <Container className="align-items-center" fluid>
          <Row>
            <Col xs={6} sm={2} className="order-sm-0">
              <TrovaLogo />
            </Col>
            <Col xs={6} sm={3} md={2} className="d-flex align-items-center justify-content-end text-right order-sm-2">
              <NavRight isAuth={isAuth} />
            </Col>
            <Col xs={12} sm={7} md={8} className="order-sm-1 mt-4 mt-sm-0">
              <SearchInput noMargin />
            </Col>
          </Row>
        </Container>
      </Box>
    )
  }

  return (
    <Box
      padding={'20px 15px'}
      alignItems={'center'}
      display={'flex'}
      width={'100%'}
    >
      {hasLogo && <TrovaLogo hasText={logoText} />}
      <NavRight isAuth={isAuth} />
    </Box>
  );
})

export default Navigation;